import angular from 'angular';
import uiRouter from 'angular-ui-router';
import CityComponent from './city.component';

let CityModule = angular
  .module('City', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newCity', {
        url: '/cities/new',
        component: 'city',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          provinces: ProvincesService =>
            ProvincesService.find({
              order: 'name ASC'
            })
        }
      })
      .state('editCity', {
        url: '/cities/:id',
        component: 'city',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          city: (CitiesService, $stateParams) =>
            CitiesService.findById($stateParams.id, {
              include: ['province']
            }),
          provinces: ProvincesService =>
            ProvincesService.find({
              order: 'name ASC'
            })
        }
      });
  })
  .component('city', CityComponent).name;

export default CityModule;
